import { useTranslation } from 'react-i18next';

import { CustomButton } from '../../../../../UiComponentsLibrary/CustomButton';
import { ButtonConfig } from '../../config/buttonConfig';
import { CardActionsFlex } from './BookingActionButtons.styles';

interface BookingActionButtonsProps {
  buttonConfig: ButtonConfig[];
}

const BookingActionButtons = ({
  buttonConfig,
}: BookingActionButtonsProps) => {
  const { t } = useTranslation();

  return (
    <CardActionsFlex id="card-actions-flex">
      {buttonConfig.map((button) => (
        <CustomButton
          key={button.id}
          id={button.id}
          backgroundColor={button.backgroundColor}
          text={t(button.text)}
          handleOnClickCb={button.handleOnClickCb}
          disabled={button.disabled}
          tooltip={button.tooltip}
        />
      ))}
    </CardActionsFlex>
  );
};

export default BookingActionButtons;
